import { ValueOfKey } from '../../utils-types';

export const SEND_MESSAGE_WAY = {
  PUSH: 'PUSH',
  CHAT: 'CHAT',
  EMAIL: 'EMAIL',
} as const;

export type SendMessageWayTypes = ValueOfKey<typeof SEND_MESSAGE_WAY>;
